import type { NextPage } from "next";

import Page from "../components/layout/page";
import TermlyEmbed from "../components/termly-embed";

const Privacy: NextPage = () => {
  return (
    <Page
      title="Privacy Policy"
      description="Read Enerflo's Privacy Policy to understand how we collect, use, and protect your personal information."
    >
      <TermlyEmbed title="Enerflo Privacy Policy" id="45c80f61-fb5f-4451-8f22-4ea0e21f8b2f" />
    </Page>
  );
};

export default Privacy;
